import React from 'react';
import { Breadcrumb } from 'antd';
import { HomeOutlined, GlobalOutlined, EnvironmentOutlined } from '@ant-design/icons';

interface NavigationBreadcrumbProps {
  visibleLevel: 'countries' | 'pois' | 'features';
  activeCountry: string | null;
  activePOI: string | null;
  onNavigate: (level: 'countries' | 'pois' | 'features') => void;
}

const NavigationBreadcrumb: React.FC<NavigationBreadcrumbProps> = ({
  visibleLevel,
  activeCountry,
  activePOI,
  onNavigate
}) => {
  const items = [
    {
      title: (
        <span 
          onClick={() => onNavigate('countries')}
          style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '4px' }}
        >
          <GlobalOutlined />
          Countries
        </span>
      ),
    }
  ];

  if (activeCountry && (visibleLevel === 'pois' || visibleLevel === 'features')) {
    items.push({
      title: (
        <span 
          onClick={() => visibleLevel === 'features' ? onNavigate('pois') : undefined}
          style={{ 
            cursor: visibleLevel === 'features' ? 'pointer' : 'default',
            display: 'flex',
            alignItems: 'center',
            gap: '4px',
            color: visibleLevel === 'features' ? '#1890ff' : 'inherit'
          }}
        >
          <EnvironmentOutlined />
          {activeCountry}
        </span>
      ),
    });
  }

  if (activePOI && visibleLevel === 'features') {
    items.push({
      title: (
        <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
          <HomeOutlined />
          {activePOI}
        </span>
      ),
    });
  }

  return (
    <div style={{ 
      padding: '12px 16px', 
      borderBottom: '1px solid #f0f0f0',
      backgroundColor: '#fafafa'
    }}>
      <Breadcrumb 
        items={items} 
        separator=">"
        style={{ fontSize: '13px' }}
      />
    </div>
  );
};

export default NavigationBreadcrumb;